import React from "react";
import { Typography } from "@material-ui/core";
import useStyles from "./styles";

interface IMessageActions {
  content: any;
  viewMore: any;
  viewLess: any;
  viewMoreEvent: any;
  viewLessEvent: any;
  addIntent: any;
  chaTagSentiment: any;
}

const MessageData: React.FC<IMessageActions> = ({
  content,
  viewMore,
  viewLess,
  viewMoreEvent,
  viewLessEvent,
  addIntent,
  chaTagSentiment
}) => {
  const classes = useStyles();
  const getString = (data: any) => {
    if (typeof data == "object") {
      if (content.isMultiple) {
        return getNameStr(data[0]);
      }
      return data.join();
    }
    return data;
  };

  const getNameStr = (data: any) => {
    return `${data.term ? data.term : ""} 
    ${data.Description ? data.Description : ""}`;
  };

  const getDescription = () => {
    if (content.Description) {
      return (
        <div style={{ fontSize: `${localStorage.getItem("Fontsize")}px` }}>
          <b>Description :</b> {content.Description}
        </div>
      );
    }
    return "";
  };

  const getParamesData = () => {
    if (content.ParamesData) {
      return (
        <div style={{ fontSize: `${localStorage.getItem("Fontsize")}px` }}>
          <b>Parameters :</b> {content.ParamesData}
        </div>
      );
    }
    return "";
  };

  const getName = (data: any, element: string) => { 
    try {
      if (element === "name") return <span>{<b>{data.term}</b>}</span>;
      if (element === "Description")
        return (
          <span className={classes.setDatalast}>
            {data.Description}
          </span>
        );
      else if (element == "slug") return `${data.term}`;
    } catch (error) {
      return "";
    }
  };

  let datamain = JSON.stringify(content);
  let maindata = JSON.parse(datamain);
  let main = JSON.stringify(maindata);

  return (
    <Typography
      variant="body1"
      gutterBottom
      color="inherit"
      className={classes.messageTextType}
    >
      {viewMore ? (
        <div style={{ fontSize: `${localStorage.getItem("Fontsize")}px` }}>
          {content && content.isSingle || content && content.Hebrew == 0 ? (
            ""
          ) : (
            <b>{`${content.term.toUpperCase()} : `}</b>
          )}
          <br />
          {typeof content.content == "object" ? (
            content.content.map((item: any) => (
              <div>
                <a
                  href="#"
                  onClick={() => addIntent(getName(item, "slug"))}
                  className={classes.tagData}
                >
                  {getName(item, "name")}
                </a>
                <Typography className={classes.posData}>
                  {getName(item, "Description")}
                </Typography>
              </div>
            ))
          ) : (
            <div>
              {content && content.isSingle || content && content.Hebrew == 0 ? (
                <span>{content.content}</span>
              ) : (
                <span>
                  {getDescription()}
                  <br />
                  {getParamesData()}
                </span>
              )}
            </div>
          )}
          <br />
          {/* {getDescription()}
          {getParamesData()} */}
          {/* {getRank()} */}
          <a
            href="#"
            className={classes.messageColorMain}
            onClick={viewLessEvent}
          >
            view less
          </a>
        </div>
      ) : getString(datamain).length > 35 ? (
        viewLess ? (
          <div>
             {content && content.isSingle || content && content.Hebrew == 0 ? (
              <b>{getString(content.content).substring(0, 55) + `...`} </b>
            ) : (
              <span>{content && content.Hebrew == 1 ? <b>
                {content.term.toUpperCase() +
                  ": " +
                  getString(content.content).substring(0, 55) +
                  `... `}
              </b> : <b>{content.term.toUpperCase() +
                  ": " + "Description :" +content.Description.substring(0, 55) + `...` }</b>}</span>
            )}
            <a
              href="#"
              id="view_more"
              className={classes.messageColorMain}
              onClick={viewMoreEvent}
            >
              view more
            </a>
          </div>
        ) : (
          <div>
            {content && content.isSingle || content && content.Hebrew == 0 ? (
              <b>{getString(content.content).substring(0, 55) + `...`} </b>
            ) : (
              <span>{content && content.Hebrew == 1 ? <b>
                {content.term.toUpperCase() +
                  ": " +
                  getString(content.content).substring(0, 55) +
                  `... `}
              </b> : <b>{content.term.toUpperCase() +
                  ": " + "Description :" +content.Description.substring(0, 55) + `...` }</b>}</span>
            )}
            <a
              href="#"
              id="view_more"
              className={classes.messageColorMain}
              onClick={viewMoreEvent}
            >
              view more
            </a>
          </div>
        )
      ) : typeof content.content == "object" ? (
        <div style={{ fontSize: `${localStorage.getItem("Fontsize")}px` }}>
          {" "}
          <b>{content.term}</b>
          {":"}{" "}
          {content.content.map((item: any) => (
            <div>
              <a
                href="#"
                onClick={() => addIntent(getName(item, "slug"))}
                className={classes.tagData}
              >
                {getName(item, "name")}
                {/* {localStorage.setItem('slugTerm', item.slugTerm)} */}
              </a>
              <Typography
                // onClick={() => addIntent(getName(item, "po"))}
                className={classes.posData}
              >
                {getName(item, "Description")}
              </Typography>
            </div>
          ))}
        </div>
      ) : (
        content.content
      )}
      {/* {getYear()}
      {getArtist()}
      {getRank()} */}
    </Typography>
  );
};

export default MessageData;
